export default "__VITE_ASSET__D9l3lXQb__"